<template>
	<Badge
		:variant="badgeVariant"
		:class="cn('w-fit text-xs font-medium', additionalClasses)"
	>
		<span class="mr-2 size-2.5">
			<slot name="icon">
				<GraphicsTriangle />
			</slot>
		</span>

		{{ labelText }}
		<span class="ml-1 font-semibold"> {{ highlightText }} </span>
	</Badge>
</template>

<script setup lang="ts">
import type { HighlightExclusiveBadgeProps } from '.';

import { cn } from '@/utils';

import { GraphicsTriangle } from '~/components/GraphicsTriangle';

import Badge from '../ui/badge/Badge.vue';

withDefaults(defineProps<HighlightExclusiveBadgeProps>(), {
	badgeVariant: 'beige-default',
	labelText: 'Exclusivo',
	highlightText: 'PilarHomes'
});
</script>
